import Icon from '../../../ui/icons/Icon';
import NavigateLink from '../../navigateLink/navigateLink';
import classes from './MiniWidget.module.css';

const MiniWidget = ({ color, onClick, text, classNameText, className, width, height, Icon, children, link }) => {

    return (
        <NavigateLink link={link}>
            <div
                className={`${classes.Widget} ${className}`}
                style={{
                    background: color,
                    ...(width != null && { width }),
                    ...(height != null && { height }),
                }}
                onClick={onClick}
            >
                {Icon && <Icon name={Icon} size="26px" />}
                <p className={`${classNameText} ${classes.Text}`}>{text}</p>
                {children}
            </div>
        </NavigateLink >
    )
}
export default MiniWidget